export const SAVED_FILTERS_CATEGORIES = {
    PRIVATE: 'Private',
    PUBLIC: 'Public',
};
